import { Campaign } from '@/types/campaign.types';
import classes from './campaign-card.module.css';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Container from '@ui/container/container';
import { EmailTypeDisplayNames } from '@/types/email.types';
import { getCampaignStatusColor, getCampaignStatusLabel } from './utils';
import Pill from '@ui/pill/pill';

const DELETABLE_STATES: Campaign['state'][] = ['draft', 'generating', 'generated', 'published', 'scheduled'];

interface CampaignCardProps {
  campaign: Campaign;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  view?: 'grid' | 'list';
}

const CampaignCard = ({ campaign, onEdit, onDelete }: CampaignCardProps) => {
  const { title, state, /*stats,*/ thumbnailUrl } = campaign;

  const statusColor = getCampaignStatusColor(state);

  return (
    <div className={classes.card}>
      <div className={classes.preview}>
        {thumbnailUrl ? (
          <img src={thumbnailUrl} alt={title} className={classes.thumbnail} />
        ) : (
          <div className={classes.placeholder}>
            <Icon name={ICONS.EMAIL} size={32} color="var(--global-ico-text-3)" />
          </div>
        )}
        <div className={classes.actions}>
          <button className={classes.actionBtn} onClick={() => onEdit(campaign.uuid)}>
            <Icon name={ICONS.EDIT} size={16} color="var(--global-ico-text-3)" />
          </button>
          {DELETABLE_STATES.includes(state) && (
            <button className={classes.actionBtn} onClick={() => onDelete(campaign.uuid)}>
              <Icon name={ICONS.TRASH} size={16} color="var(--global-ico-text-3)" />
            </button>
          )}
        </div>
      </div>

      <div className={classes.content}>
        <div className={classes.left}>
          <Text className="H6" tag="h6" clamp={1} design="GlobalIcoText1">
            {title}
          </Text>
          <Container className="flex">
            {campaign.sourceScheduledEmail?.email_type && (
              <Text className="C2" design="GlobalIcoText3">
                {EmailTypeDisplayNames[campaign.sourceScheduledEmail.email_type]}
              </Text>
            )}
          </Container>
          {/* <div className={classes.metrics}>
            {[
              { label: 'Sent', value: stats?.sent || 0 },
              { label: 'Open', value: `${stats?.openRate || 0}%` },
              { label: 'Click', value: `${stats?.clickRate || 0}%` },
            ].map(({ label, value }, idx, arr) => (
              <Fragment key={label}>
                <Text className="S3" color="var(--global-ico-text-3)">
                  {label} <span style={{ color: 'var(--global-ico-text-1)' }}>{value}</span>
                </Text>
                {idx < arr.length - 1 && (
                  <Text className="S3" color="var(--global-ico-text-3)">
                    ·
                  </Text>
                )}
              </Fragment>
            ))}
          </div> */}
        </div>
        <Pill
          colorMix={{ color: statusColor.color, mix: statusColor.mix }}
          padding="4px 12px"
          borderRadius="16px"
          borderColor={statusColor.color}
          borderWidth="2px"
        >
          <Text className="C1" color={statusColor.color}>
            {getCampaignStatusLabel(state)}
          </Text>
        </Pill>
      </div>
    </div>
  );
};

export default CampaignCard;
